<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Tarifas de camino</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarTarifa(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarTarifa(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>

        <v-col cols="6">
          <v-text-field 
            v-model="modelTarifa.fecha_desde" 
            label="Fecha desde" 
            placeholder="DD/MM/AAAA"
            dense 
            outlined 
            :dark="dark" 
            autocomplete="off"
            @input="onInputFechaDesde"
            :error-messages="errorFechaDesde"
            hint="Formato: DD/MM/AAAA (ej: 31/01/2025)"
            persistent-hint
            maxlength="10">
          </v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field 
            v-model="modelTarifa.fecha_hasta" 
            label="Fecha hasta" 
            placeholder="DD/MM/AAAA"
            dense 
            outlined 
            :dark="dark" 
            autocomplete="off"
            @input="onInputFechaHasta"
            :error-messages="errorFechaHasta"
            hint="Formato: DD/MM/AAAA (ej: 31/12/2025)"
            persistent-hint
            maxlength="10">
          </v-text-field>
        </v-col>
        <v-col cols="12" class="mt-6">
          <v-text-field v-model="modelTarifa.precio_ind" label="Precio individual" type="number" dense outlined :dark="dark" autocomplete="off"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="modelTarifa.precio_doble" label="Precio doble" type="number" dense outlined :dark="dark" autocomplete="off"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="modelTarifa.precio_triple" label="Precio triple" type="number" dense outlined :dark="dark" autocomplete="off"></v-text-field>
        </v-col>
        <v-col cols="12" class="mt-4">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <div class="text-subtitle-2 font-weight-medium">Suplemento</div>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="modelTarifa.suplemento_fecha_desde"
            label="Suplemento desde"
            placeholder="DD/MM/AAAA"
            dense
            outlined
            :dark="dark"
            autocomplete="off"
            @input="onInputSuplementoFechaDesde"
            :error-messages="errorSuplementoDesde"
            hint="Formato: DD/MM/AAAA (ej: 01/07/2025)"
            persistent-hint
            maxlength="10"></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="modelTarifa.suplemento_fecha_hasta"
            label="Suplemento hasta"
            placeholder="DD/MM/AAAA"
            dense
            outlined
            :dark="dark"
            autocomplete="off"
            @input="onInputSuplementoFechaHasta"
            :error-messages="errorSuplementoHasta"
            hint="Formato: DD/MM/AAAA (ej: 31/08/2025)"
            persistent-hint
            maxlength="10"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="modelTarifa.suplemento"
            label="Suplemento (%)"
            type="number"
            dense
            outlined
            :dark="dark"
            autocomplete="off"></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "CaminoTarifaFormulario",
  components: {},
  data: () => ({
    loading: false,
    tab: null,
    languages: ['Español', 'Inglés', 'Alemán'],
    errorFechaDesde: '',
    errorFechaHasta: '',
    errorSuplementoDesde: '',
    errorSuplementoHasta: '',
  }),

  props: {
    modelTarifa: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },

    camino: {
      type: Object,
      required: true,
    }
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  watch: {
    modelTarifa: {
      immediate: true,
      handler(nuevaTarifa) {
        this.normalizarFechasTarifa(nuevaTarifa);
      },
    },
  },


  methods: {
    ...mapActions("caminos", ["createTarifa", "updateTarifa"]),

    _cerrarVentana() {
      this.$emit("soloCerrar", this.modelTarifa);
    },

    normalizarFechasTarifa(tarifa) {
      if (!tarifa) {
        return;
      }

      tarifa.fecha_desde = this.formatearFechaParaMostrar(tarifa.fecha_desde);
      tarifa.fecha_hasta = this.formatearFechaParaMostrar(tarifa.fecha_hasta);
      tarifa.suplemento_fecha_desde = this.formatearFechaParaMostrar(tarifa.suplemento_fecha_desde);
      tarifa.suplemento_fecha_hasta = this.formatearFechaParaMostrar(tarifa.suplemento_fecha_hasta);
    },

    aplicarMascaraFecha(valor) {
      const numeros = String(valor || "").replace(/\D/g, "").slice(0, 8);

      if (numeros.length <= 2) {
        return numeros;
      }

      if (numeros.length <= 4) {
        return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
      }

      return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
    },

    onInputFechaDesde() {
      this.modelTarifa.fecha_desde = this.aplicarMascaraFecha(this.modelTarifa.fecha_desde);
      this.validarFechaDesde();
    },

    onInputFechaHasta() {
      this.modelTarifa.fecha_hasta = this.aplicarMascaraFecha(this.modelTarifa.fecha_hasta);
      this.validarFechaHasta();
    },

    onInputSuplementoFechaDesde() {
      this.modelTarifa.suplemento_fecha_desde = this.aplicarMascaraFecha(this.modelTarifa.suplemento_fecha_desde);
      this.validarSuplementoDesde();
    },

    onInputSuplementoFechaHasta() {
      this.modelTarifa.suplemento_fecha_hasta = this.aplicarMascaraFecha(this.modelTarifa.suplemento_fecha_hasta);
      this.validarSuplementoHasta();
    },

    validarFechaDesde() {
      this.errorFechaDesde = "";
      if (this.modelTarifa.fecha_desde && !this.isValidDateFormat(this.modelTarifa.fecha_desde)) {
        this.errorFechaDesde = "El formato debe ser DD/MM/AAAA (ej: 31/01/2025)";
      }
    },

    validarFechaHasta() {
      this.errorFechaHasta = "";
      if (this.modelTarifa.fecha_hasta && !this.isValidDateFormat(this.modelTarifa.fecha_hasta)) {
        this.errorFechaHasta = "El formato debe ser DD/MM/AAAA (ej: 31/12/2025)";
      }
    },

    validarSuplementoDesde() {
      this.errorSuplementoDesde = "";
      if (this.modelTarifa.suplemento_fecha_desde && !this.isValidDateFormat(this.modelTarifa.suplemento_fecha_desde)) {
        this.errorSuplementoDesde = "El formato debe ser DD/MM/AAAA (ej: 01/07/2025)";
      }
    },

    validarSuplementoHasta() {
      this.errorSuplementoHasta = "";
      if (this.modelTarifa.suplemento_fecha_hasta && !this.isValidDateFormat(this.modelTarifa.suplemento_fecha_hasta)) {
        this.errorSuplementoHasta = "El formato debe ser DD/MM/AAAA (ej: 31/08/2025)";
      }
    },

    formatearFechaParaMostrar(fecha) {
      const valor = String(fecha || "").trim();
      if (!valor) {
        return "";
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
        return valor;
      }

      const matchIso = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!matchIso) {
        return valor;
      }

      return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
    },

    convertirFechaAFormatoISO(fecha) {
      const valor = String(fecha || "").trim();
      const match = valor.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match) {
        return valor;
      }

      return `${match[3]}-${match[2]}-${match[1]}`;
    },

    isValidDateFormat(dateString) {
      // Expresión regular para validar formato DD/MM/YYYY
      const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
      
      if (!dateRegex.test(dateString)) {
        return false;
      }

      // Validar que sea una fecha válida
      const [day, month, year] = dateString.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      
      return date.getFullYear() === year && 
             date.getMonth() === month - 1 && 
             date.getDate() === day;
    },

    
    async _guardarTarifa(cerrar) {
      this.validarFechaDesde();
      this.validarFechaHasta();
      this.validarSuplementoDesde();
      this.validarSuplementoHasta();

      if (this.errorFechaDesde || this.errorFechaHasta || this.errorSuplementoDesde || this.errorSuplementoHasta) {
        return;
      }

      const modelTarifaPayload = {
        ...this.modelTarifa,
        fecha_desde: this.convertirFechaAFormatoISO(this.modelTarifa.fecha_desde),
        fecha_hasta: this.convertirFechaAFormatoISO(this.modelTarifa.fecha_hasta),
        suplemento_fecha_desde: this.convertirFechaAFormatoISO(this.modelTarifa.suplemento_fecha_desde),
        suplemento_fecha_hasta: this.convertirFechaAFormatoISO(this.modelTarifa.suplemento_fecha_hasta),
      };

      this.loading = true;
      if (this.accion == "crear") {
        var res = await this.createTarifa([
          this.access_token,
          modelTarifaPayload,
          this.camino.id
        ]);
        const params = {};
      } else if (this.accion == "editar") {
        /*  const puntoInicio = this.puntos.find(p => p.nombre === this.modelEtapa.inicio_punto.nombre);
          this.modelEtapa.inicio_punto = puntoInicio;
          const puntoFinal = this.puntos.find(punto => punto.nombre === this.modelEtapa.final_punto.nombre);
          this.modelEtapa.final_punto = puntoFinal;
          */
        var res = await this.updateTarifa([
          this.access_token,
          modelTarifaPayload,
        ]);
       
      }
      if (cerrar) {
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
